module.exports = __webpack_public_path__ + "img/screen.6edee6ff.png";